const wrapOne = (element, wrapper) => {
  wrapper = wrapper || document.createElement('div');
  wrapper.classList.add('soh--element-wrapper');
  element.parentNode.insertBefore(wrapper, element);
  wrapper.appendChild(element);
  return wrapper;
}

const wrapAll = (els, wrapper) => {

}

export {
  wrapOne,
  wrapAll
}
